import { ActionIcon, Card, Group, Text } from '@mantine/core'
import { IconExternalLink, IconPaperclip, IconX } from '@tabler/icons-react'
import { getFileLogo } from '../../files/fileUtils';
import { useMemo } from 'react';
import AudioVisualizer from '../../../../components/View/AudioVisualizer';

const FileItemMessage = ({ file, setFile, isVocalMessage }) => {
    const removeFile = (e) => {
        e.stopPropagation()
        e.preventDefault()
        setFile(null);
    }

    const filePreview = useMemo(() => {
        if (!file) return null;

        const isImage = file.type === "image" ||
            file.file_url?.endsWith(".jpg") ||
            file.file_url?.endsWith(".jpeg") ||
            file.file_url?.endsWith(".png") ||
            file.file_url?.endsWith(".gif");

        const isAudio = file.type === "audio" ||
            file.file_url?.endsWith(".mp3") ||
            file.file_url?.endsWith(".wav") ||
            file.file_url?.endsWith(".m4a");

        if (isImage) {
            return (
                <a href={file.file_url} target="_blank" rel="noopener noreferrer">
                    <img src={file.file_url} style={{ maxWidth: "400px", maxHeight: "400px" }} alt="preview" />
                </a>
            );
        }

        if (isAudio) {
            // Render the visualizer if it's a vocal message
            if (isVocalMessage) {
                return <AudioVisualizer audioUrl={file.file_url} />;
            }

            // Standard audio player fallback
            return (
                <audio controls>
                    <source src={file.file_url} type="audio/mpeg" />
                    Your browser does not support the audio element.
                </audio>
            );
        }
    }, [file, isVocalMessage]); // Make sure to add isVocalMessage to the dependency array

    return (
        <Group my={'md'} key={file?.id} >
            {
                !isVocalMessage &&
                <IconPaperclip />
            }
            <Card withBorder p={"sm"} component={"a"} style={{ flexGrow: 1 }}>
                <Group>
                    {getFileLogo(file, { size: 24 })}
                    <Group mr={64} >
                        <Text> {file?.name || "Voice Message"} </Text>
                        <ActionIcon variant='subtle' component={"a"} href={file?.file_url} target='_blank'>
                            <IconExternalLink size={20} />
                        </ActionIcon>
                    </Group>

                    {
                        !isVocalMessage &&
                        <ActionIcon ml={"auto"} color='red' variant='subtle' onClick={removeFile}>
                            <IconX />
                        </ActionIcon>
                    }
                </Group>

                {filePreview ? (
                    <Group mt="sm" style={{ width: '100%' }}>
                        {filePreview}
                    </Group>
                ) : null}
            </Card>
        </Group>
    )
}

export default FileItemMessage;